const Wifi = ({ color = "var(--grey400)" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2986_35606)">
        <path
          d="M8.33331 12H8.3402"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.44794 10.1147C6.94801 9.61483 7.62617 9.33398 8.33327 9.33398C9.04038 9.33398 9.71853 9.61483 10.2186 10.1147"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.56195 8.22919C5.0572 7.73391 5.64515 7.34104 6.29224 7.07299C6.93933 6.80495 7.63288 6.66699 8.33328 6.66699C9.03369 6.66699 9.72724 6.80495 10.3743 7.07299C11.0214 7.34104 11.6094 7.73391 12.1046 8.22919"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.67664 6.3435C5.80064 3.21883 10.866 3.21883 14.01 6.3435"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2986_35606">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.333313)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Wifi;
